export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy border-t border-ivory/10 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <p className="font-serif italic text-2xl md:text-3xl text-ivory/90 leading-snug max-w-md">
              We open the doors that remain closed to everyone else.
            </p>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <p className="text-gold text-xs tracking-[0.2em] uppercase mb-4">
              Explore
            </p>
            <ul className="space-y-3 font-sans font-light text-ivory/70">
              <li><a href="#manifesto" className="hover:text-gold transition-colors duration-300">Manifesto</a></li>
              <li><a href="#services" className="hover:text-gold transition-colors duration-300">Services</a></li>
              <li><a href="#experiences" className="hover:text-gold transition-colors duration-300">Experiences</a></li>
              <li><a href="#membership" className="hover:text-gold transition-colors duration-300">Membership</a></li>
              <li><a href="#apply" className="hover:text-gold transition-colors duration-300">Apply</a></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-gold text-xs tracking-[0.2em] uppercase mb-4">
              Connect
            </p>
            <ul className="space-y-3 font-sans font-light text-ivory/70">
              <li><a href="#contact" className="hover:text-gold transition-colors duration-300">Enquiries</a></li>
              <li><a href="#apply" className="hover:text-gold transition-colors duration-300">Partners</a></li>
              <li><span>Instagram</span></li>
              <li><span>LinkedIn</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-ivory/10 pt-10">
          <h2 className="font-serif font-light text-ivory leading-none tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] flex items-baseline gap-3">
            The Eighth Key
            <span className="text-gold text-2xl md:text-3xl">Concierge</span>
          </h2>
          <div className="mt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-ivory/50 font-sans font-light text-xs tracking-wide">
            <span>© {new Date().getFullYear()} The Eighth Key. By invitation only.</span>
            <span>London · Dubai · Singapore · New York · India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
